<template>
  <SingleFinderWrapper>
    <div
      v-if="tripid !== '666' && tripid[0] !== 'P'"
      class="flex justify-center items-center -mx-1"
    >
      <div
        class="inline text-[14px] px-1"
        :class="{ 'order-2': labelSide === 'right'}"
      >
        {{ $t(isTripActive ? 'activated' : 'activate') }}
      </div>
      <div class="px-1 flex items-center h-full">
        <div
          class="dot cursor-pointer"
          :class="isTripActive ? 'dot-active' : ''"
          @click="toggleActivateSinglefinderSearchForTrip"
        />
      </div>
    </div>
  </SingleFinderWrapper>
</template>

<script setup>
import events from '@layers/web/constants/events.js'

const props = defineProps({
  tripid: {
    type: String,
    required: true,
  },

  registeredPersonsList: {
    type: Array,
    default: () => [],
  },

  registeredPersonsCount: {
    type: Number,
    default: 0,
  },

  labelSide: {
    type: String,
    default: 'left',
  },
})

const userStore = useUserStore()

const {
  getMemberSingleList,
  memberProfile,
} = storeToRefs(userStore)

const isTripActive = computed(() => {
  const tripIdStr = props.tripid
  return (getMemberSingleList.value || []).some(activeTrip => tripIdStr.includes(String(activeTrip.trip_id)))
})

const { $event } = useNuxtApp()

const toggleActivateSinglefinderSearchForTrip = async () => {
  if (isTripActive.value) {
    await userStore.memberSingleFinderDelete(props.tripid)
    $event.$emit(events.calendarRefresh, {
      tripid: props.tripid,
      rowData: {
        single_finder_count: Math.max(props.registeredPersonsCount - 1, 0),
        single_finder_list: props.registeredPersonsList.filter((singleFinder) => singleFinder.id !== memberProfile.value.config?.id),
      },
    })
  } else {
    await userStore.memberSingleFinderAdd(props.tripid)
    $event.$emit(events.calendarRefresh, {
      tripid: props.tripid,
      rowData: {
        single_finder_count: props.registeredPersonsCount + 1,
        single_finder_list: [...props.registeredPersonsList, memberProfile.value?.config],
      },
    })
    $event.$emit(events.calendarRefresh, {})
  }

  await Promise.all([
    userStore.fetchMemberSingleFinderList(),
    userStore.fetchMemberProfile(),
  ])
}
</script>

<style lang="scss" scoped>
.dot {
  width: 18px;
  height: 18px;
  background-color: theme('colors.alt-gray');
  border-radius: 50%;
  display: inline-block;

  &-active {
    background-color: theme('colors.blue.DEFAULT');
  }
}
</style>
